import MotionWrapper from '../../../layouts/MotionWrapper';
import AppVersion from '../../../containers/AppVersion';
import LegalContainer from '../../../containers/Legal';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';

export default function Legal() {
    const [versionModalOpen, setVersionModalOpen] = useState(false);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (!e.shiftKey || e.key.toLowerCase() !== 'q') return;

            e.preventDefault();
            setVersionModalOpen(true);
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    return (
        <MotionWrapper className={styles.container}>
            <LegalContainer />
            {versionModalOpen && <AppVersion onClose={() => setVersionModalOpen(false)} />}
        </MotionWrapper>
    );
};
